import styled from 'styled-components/macro';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const DateTimeCounter = styled.div`
  ${FLEX_CONTAINER.FlexRow}
  width: 220px;
  height: 220px;
  background: linear-gradient(
    155.67deg,
    rgba(255, 255, 255, 0.5015) -7.08%,
    rgba(255, 255, 255, 0.1105) 110.41%
  );
  border: 1px solid rgba(15, 66, 90, 0.33);
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(20px);
  border-radius: 12px;

  @media only screen and (max-width: 1277px) {
    width: 155px;
    height: 155px;
  }

  @media only screen and (max-width: 875px) {
    width: 110px;
    height: 110px;
  }

  @media only screen and (max-width: 620px) {
    width: 70px;
    height: 70px;
  }
`;

export const RemainingCount = styled.div`
  ${FONTS.font36}
  color: ${COLORS.white};
  width: 100%;
  text-align: center;
  ${FONT_FAMILY.FontBold};

  @media only screen and (max-width: 620px) {
    ${FONTS.font24}
  }

  @media only screen and (max-width: 400px) {
    ${FONTS.font16}
  }
`;
